var $ = require('../internals/export'); // `Number.isNaN` method
// https://tc39.github.io/ecma262/#sec-number.isnan


$({
  target: 'Number',
  stat: true
}, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});